/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, OnDestroy} from '@angular/core';
import {NavController} from "ionic-angular";
import {AuthService} from "../../providers/auth-service";
import {Subscription} from "rxjs";
import {PageRefs} from "../../shared/PageRefs";
// import {QRScanner, QRScannerStatus} from "@ionic-native/qr-scanner";
import {UserInterfacingService} from "../../providers/user-interfacing-service/user-interfacing-service";
import {EventService} from "../../providers/event-service";

/**
 * Generated class for the HomeControlOptions component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'home-control-options',
  templateUrl: 'home-control-options.html'
})
export class HomeControlOptions implements OnDestroy {

  private isUserLoggedIn: boolean = false;
  private _subscription: Subscription;

  constructor(private navCtrl: NavController,
              // private qrScanner: QRScanner,
              private uiService: UserInterfacingService,
              private eventService: EventService,
              private auth: AuthService) {
    this._subscription = this.auth.userId.subscribe(uid => {
      this.isUserLoggedIn = uid != null;
    });
  }

  navigateToFindEvent() {
    this.navCtrl.push(PageRefs.findEvent.name);
  }

  navigateToMyEvents() {
    this.navCtrl.push(PageRefs.myEvents.name);
  }

  navigateToProfile() {
    this.navCtrl.push(PageRefs.profile.name);
  }

  logout() {
    this.auth.logout().then(() => {
      console.log('logged out');
    }, err => {
      console.error(err);
    });
  }

  // navigateToMyDancers() {
  //
  // }
  //
  // navigateToMyStudios() {
  //
  // }

  // scanCode() {
  //   console.log('scanCode()');
  //
  //   this.qrScanner.prepare()
  //     .then((status: QRScannerStatus) => {
  //       console.log('status is ');
  //       console.log(status);
  //
  //       if (status.authorized) {
  //         // camera permission was granted
  //
  //        this._doScan();
  //
  //         // wait for user to scan something, then the observable callback will be called
  //
  //       } else if (status.denied) {
  //         console.warn('qr status denied');
  //         // camera permission was permanently denied
  //         // you must use QRScanner.openSettings() method to guide the user to the settings page
  //         // then they can grant the permission from there
  //         const alert = this.uiService.showOkAlert('Permissions Needed', 'Permissions must be turned on in settings to enable this feature');
  //         alert.onDidDismiss(() => {
  //           this.qrScanner.openSettings();
  //         });
  //       } else {
  //         console.warn('qr other status');
  //         const alert = this.uiService.showOkAlert('Permissions Needed', 'Permissions must be turned on in settings to enable this feature');
  //         // permission was denied, but not permanently. You can ask for permission again at a later time.
  //       }
  //     })
  //     .catch((e: any) => console.log('Error is', e));
  // }
  //
  // private _doScan() {
  //   console.log('in doScan');
  //
  //   // start scanning
  //   let scanSub = this.qrScanner.scan().subscribe((text: string) => {
  //     console.log('Scanned something', text);
  //
  //     this.eventService.getEventForCode(text).then(result => {
  //       if (result) {
  //         this.eventService.purchaseEvent(result)
  //           .then(success => {
  //             this.uiService.showToastMessage('Event added successfully');
  //           }, err => {
  //             console.error(err);
  //             this.uiService.showDismissibleError('Error redeeming code');
  //           });
  //       } else {
  //         // code does not exist
  //         this.uiService.showDismissibleError('This code is not valid');
  //       }
  //     }, err => {
  //       this.uiService.showDismissibleError('Error validating code');
  //     });
  //
  //     this.qrScanner.hide(); // hide camera preview
  //     window.document.querySelector('ion-app').classList.remove('transparent-body');
  //
  //
  //     scanSub.unsubscribe(); // stop scanning
  //   });
  //
  //   // show camera preview
  //   this.qrScanner.show();
  //   window.document.querySelector('ion-app').classList.add('transparent-body');
  //
  // }

  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/home-control-options/home-control-options.ts